(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="ch-footer-"]').forEach(function (footer) {
      var drawers = footer.querySelectorAll('.cf-accordion');

      function setDrawerState() {
        var isMobile = window.innerWidth < 750;

        drawers.forEach(function (item) {
          if (isMobile) {
            item.removeAttribute('open');
          } else {
            /* Desktop: always show the menu/contact contents */
            item.setAttribute('open', '');
          }
        });
      }

      setDrawerState();

      drawers.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (window.innerWidth < 750 && item.open) {
            drawers.forEach(function (other) {
              if (other !== item) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(setDrawerState, 100);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
